import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { ErrorMessage, Form, Formik } from 'formik';
import * as Yup from 'yup';
import * as actions from '../../features/schedule/redux/actions';
import CustomInputWithIcon from '../../common/ui/CustomInputWithIcon';
import CustomSelect from '../../common/formElements/CustomSelect';
import { builderSurfaceJsonContentHeader } from '../../common/utils/restApiHeaderUtils';
import axios from 'axios';

export class MetaDataMappingSchedule extends Component {
  static propTypes = {
    schedule: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };

  state = {
    selectedMetaDataCollection: null,
    mappings: [],
    metaDataCollections: [],
    selectedMapping: null,
    allCollections: [],
  };

  async componentDidMount() {
    const { projectId, version } = this.props;
    const header = builderSurfaceJsonContentHeader(projectId);
    const response = await axios.get(
      `${process.env.REACT_APP_BUILDER_ENGINE}v${version}/collections/${projectId}/project`,
      header,
    );
    this.setState({ allCollections: response.data });
    const metaDataCollections = response.data.filter(
      (collection) => collection.metaDataTableMapping.length,
    );
    this.setState({ metaDataCollections });
  }

  handleSubmit = (values) => {
    const { mappings, allCollections } = this.state;
    const selectedMapping = mappings.find((mapping) => mapping.uuid === values.metaDataMapping);
    const targetCollectionDetails = allCollections.find(
      (collection) => collection.uuid === selectedMapping.targetCollection,
    );
    const targetDataCollectionName = targetCollectionDetails.collectionName || '';
    const updatedValues = {
      ...values,
      targetDataCollection: targetDataCollectionName,
    };
    this.props.handleSubmit(updatedValues);
  };

  scheduleSchema = () => {
    const { taskDetail } = this.props;
    if (taskDetail.settings) {
      const { settings } = taskDetail;
      const { metaDataCollection, metaDataMapping } = settings;
      if (metaDataCollection && metaDataMapping)
        return {
          metaDataCollection,
          metaDataMapping,
        };
    } else {
      return {
        metaDataCollection: '',
        metaDataMapping: '',
      };
    }
  };

  scheduleSchemaValidation = () => {
    return Yup.object().shape({
      metaDataCollection: Yup.string().required('Meta Data Collection is required.'),
      metaDataMapping: Yup.string().required('Mapping selection is required.'),
    });
  };

  handleCancel = () => {
    const { projectId, version, history } = this.props;
    history.push(`/2.0/schedule/${version}/v/${projectId}/`);
  };

  handleMetaDataTableChange = (name, value) => {
    this.setState({ [name]: value });
    const { metaDataCollections } = this.state;
    const selectedMetaDataCollection = metaDataCollections.find(
      (collection) => collection.collectionName === value,
    );
    this.setState({ selectedMetaDataCollection });
    const mappings =
      selectedMetaDataCollection && selectedMetaDataCollection.metaDataTableMapping.length
        ? selectedMetaDataCollection.metaDataTableMapping
        : [];
    this.setState({ mappings });
  };

  handleMappingChange = (name, value) => {
    this.setState({ [name]: value });
  };

  render() {
    const { metaDataCollections, mappings } = this.state;
    const updateSchedulePending = false;
    const metaDataCollectionOptions = metaDataCollections.map((collection) => ({
      label: collection.collectionTitle,
      value: collection.collectionName,
    }));
    const mappingOptions = mappings.map((mapping) => ({
      label: mapping.mappingName,
      value: mapping.uuid,
    }));

    return (
      <div className="schedule-meta-data-task-schedule">
        <Formik
          enableReinitialize={true}
          initialValues={this.scheduleSchema()}
          validationSchema={this.scheduleSchemaValidation()}
          onSubmit={(values, { setSubmitting, resetForm }) => {
            this.handleSubmit(values);
            setSubmitting(false);
            resetForm();
          }}
        >
          {({ isSubmitting, values, setFieldValue, setFieldTouched }) => (
            <Form className="form-horizontal">
              <div className="row">
                <div className="col-md-6">
                  <CustomInputWithIcon
                    icon="collection"
                    required={true}
                    title="Meta Data Collection"
                  >
                    <CustomSelect
                      name="metaDataCollection"
                      options={metaDataCollectionOptions}
                      onChange={setFieldValue}
                      onBlur={setFieldTouched}
                      placeholder="Select Meta Data Collection"
                      value={values.metaDataCollection}
                      onChangeValue={this.handleMetaDataTableChange}
                    />
                    <p className="text-danger">
                      <ErrorMessage name="metaDataCollection" />
                    </p>
                  </CustomInputWithIcon>
                </div>

                <div className="col-md-6">
                  <CustomInputWithIcon icon="list" required={true} title="Mappings">
                    <CustomSelect
                      name="metaDataMapping"
                      options={mappingOptions}
                      onChange={setFieldValue}
                      onBlur={setFieldTouched}
                      placeholder="Select Mapping"
                      value={values.metaDataMapping}
                      onChangeValue={this.handleMappingChange}
                    />
                    <p className="text-danger">
                      <ErrorMessage name="metaDataMapping" />
                    </p>
                  </CustomInputWithIcon>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <button
                    type="button"
                    className="btn btn-outline-secondary btn-md"
                    onClick={this.handleCancel}
                  >
                    <i className="wb webconnect-times"></i> Cancel
                  </button>
                </div>
                <div className="col-md-6 text-right">
                  <button
                    type="submit"
                    className="btn btn-theme-submit btn-md"
                    disabled={updateSchedulePending}
                  >
                    Schedule
                  </button>
                </div>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    schedule: state.schedule,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(MetaDataMappingSchedule);
